import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useCustomToast from "./useCustomToast";

export const useHaveEmail = () => {
  const navigate = useNavigate();
  const toast = useCustomToast();

  useEffect(() => {
    const registeredEmail = localStorage.getItem("registeredEmail");

    if (!registeredEmail) {
      navigate("/register", { replace: true });
      return toast({
        title: "Daftarkan email anda terlebih dahulu",
      });
    }
  }, [toast, navigate]);
};
